import chartLow from "../assets/images/ChartLow.svg";
import chartHigh from "../assets/images/ChartHigh.svg";
import { Link } from "react-router-dom";
import { useGetUserInfo } from "hooks/useGetUserInfo";
import { routePath } from "config/routeMgt/routePath";

interface IProps {
  title: string;
  count: number;
  percentage: number;
}

export const HomeCard = ({ count, percentage, title }: IProps) => {
  const chatImage = percentage <= 10 ? chartLow : chartHigh;
  const color = percentage <= 10 ? "text-red-600" : "text-green-600";
  const statusPath = title.toLowerCase();

  const { userInfo } = useGetUserInfo();

  const isTalent = userInfo?.talent;
  return (
    <div className="bg-white border rounded-md p-3 text-accent relative">
      <div className="flex justify-between items-center">
        {isTalent ? (
          <Link to={`/invites/pending`} className="text-blue-600 underline hover:text-blue-800 transition-colors duration-200">
            {title} Invites
          </Link>
        ) : (
          <Link
            to={`/recruiter-invites/${statusPath}`}
            className="text-blue-600 underline hover:text-blue-800 transition-colors duration-200"
          >
            {title} Invites
          </Link>
        )}
      </div>

      <div className="relative pt-5">
        <h2 className="font-extrabold text-2xl">{count.toLocaleString()}</h2>
        <img
          src={chatImage}
          alt="chat"
          loading="lazy"
          className="absolute right-0 top-[20%] h-16 w-auto object-contain pointer-events-none"
        />
      </div>

      <div className="flex justify-between items-end mt-3 relative z-10">
        <div className="flex items-center gap-3">
          <div className={`${color} flex text-sm items-center gap-2`}>
            <i className="ri-arrow-up-line"></i>
            <span>{percentage}%</span>
          </div>
          <div className="text-sm">vs last month</div>
        </div>
      </div>
    </div>
  );
};
